import { createFileRoute } from "@tanstack/react-router";

import { CoachQuestionnaireDetailsPage } from "src/pages/CoachQuestionnaireDetailsPage";

export const Route = createFileRoute(
  "/_auth/_coach/questionnaires/$questionnaireId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <CoachQuestionnaireDetailsPage />;
}
